import AbsModal from './AbsModal';
import {makeElement} from '../common/Utils.js';

/**
 * Alert Confirm main
 */
export default class AlertConfirm extends AbsModal{

    constructor(_type='alert'){
        super();
        this.type = _type;
    }

    template(){
        const temp = makeElement( super.template() );

        const footerBtnTmpl = makeElement( `
        <div>
            <button type="button" class="nc-modal__btn nc-modal__btn--pri">
                <span class="nc-modal__btn-text">${this.options.primaryBtnText}</span>
            </button>
            ${this.type==='confirm' ? 
            `<button type="button" class="nc-modal__btn nc-modal__btn--sec">
                <span class="nc-modal__btn-text">${this.options.cancelBtnText}</span>
            </button>`:``
            }
        </div>` );

        temp.querySelector('.nc-modal__footer').appendChild(footerBtnTmpl);
        return temp;
    }

    open(_options={}){
        this.initialOptions.useBackdropClickClose = false;
        this.optionsSetting(_options);
        this.makeBackdropEl();
        this.makeModalEl();
        this.setBtns();
        this.addEvents();

        super.open();
    }
    
    close(_result=true){
        super.close(_result);

        setTimeout(() => {
            this.modalEl.parentNode.removeChild(this.modalEl);
            this.backdropEl.parentNode.removeChild(this.backdropEl);
        }, 100);
    }


} // end of class